import React from 'react';
import { ApolloProvider } from '@apollo/client';
import './App.css';
import { clientConfig } from './apolo/client-config';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRoutes } from './routes';

export const App = () => {
  return (
    <ApolloProvider client={clientConfig}>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </ApolloProvider>
  );
};
